<content-block [title]="'Preference.Notifications.Title' | translate" [headerActions]="contentBlockActions" classList="has-spacer">
	<p>
		<b>{{ 'Preference.Notifications.Header' | translate }}</b>
	</p>

	<form [formGroup]="form" *ngIf="form">
		<div class="table-responsive">
			<table class="table table-borderless">
				<thead>
					<tr>
						<th class="col-md-4"></th>
						<th class="col-md-4">{{ 'Preference.Notifications.Actif' | translate }}</th>
						<th class="col-md-4">{{ 'Preference.Notifications.APartir' | translate }}</th>
					</tr>
				</thead>
				<tbody formArrayName="preferences">
					<tr class="table-row" *ngFor="let prefGroup of form.controls.preferences.controls; let i = index" [formGroupName]="i">
						<td class="col-md-4">
							{{ prefGroup.controls.label.value }}
						</td>
						<td class="col-md-4">
							<div [ngClass]="{ 'non-interactive': !isEditMode }">
								<btn-toggle formControlName="actif"></btn-toggle>
							</div>
						</td>
						<td class="col-md-4">
							<div *ngIf="!notificationsWithoutValidatorsAndValue.includes(prefGroup.controls.code.value)">
								<input
									class="form-control"
									type="text"
									formControlName="valeur"
									inputRestriction="configuredDecimal"
									configurationNumber="0"
									[withAmountSeparation]="true"
									*ngIf="isEditMode"
									[placeholder]="prefGroup.controls.valeur.enabled  ? ('Preference.Notifications.SaisieMontant' | translate) : ''"/>
 
								<form-control-feedback [field]="prefGroup.controls.valeur"></form-control-feedback>
							</div>
							<div *ngIf="!isEditMode">
								<span *ngIf="prefGroup.controls.valeur.value">
									{{ +prefGroup.controls.valeur.value.replace(',', '.') | amount: null : null : 2 }}
								</span>
								<span *ngIf="!prefGroup.controls.valeur.value"> - </span>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="row emails">
			<p>
				<b>{{ 'Preference.Notifications.HeaderEmail' | translate }}</b>
			</p>

			<div class="col-md-4 form-group">
				<div class="cell-title form-label" [ngClass]="{ 'form-label-required': isEmail1Required }">
					{{ 'Preference.Notifications.Email1' | translate }}
				</div>
				<input
					class="form-control"
					formControlName="email1"
					name="email1"
					autocomplete="section-email1 email"
					[class.is-invalid]="form?.controls?.email1?.dirty && form?.controls?.email1?.invalid"
					*ngIf="isEditMode"
				/>
				<form-control-feedback [field]="form?.controls?.email1"></form-control-feedback>
				<span class="cell-value" *ngIf="!isEditMode">
					{{ form.value.email1 }}
				</span>
			</div>
			<div class="col-md-4 form-group">
				<div class="cell-title form-label">{{ 'Preference.Notifications.Email2' | translate }}</div>
				<input
					class="form-control"
					formControlName="email2"
					name="email2"
					autocomplete="section-email2 email"
					[class.is-invalid]="form?.controls?.email2?.dirty && form?.controls?.email2?.invalid"
					*ngIf="isEditMode"
				/>
				<form-control-feedback [field]="form?.controls?.email2"></form-control-feedback>
				<span class="cell-value" *ngIf="!isEditMode">
					{{ form.value.email2 }}
				</span>
			</div>
			<div class="col-md-4 form-group">
				<div class="cell-title form-label">{{ 'Preference.Notifications.Email3' | translate }}</div>
				<input
					class="form-control"
					formControlName="email3"
					name="email3"
					autocomplete="section-email3 email"
					[class.is-invalid]="form?.controls?.email3?.dirty && form?.controls?.email3?.invalid"
					*ngIf="isEditMode"
				/>
				<form-control-feedback [field]="form?.controls?.email3"></form-control-feedback>
				<span class="cell-value" *ngIf="!isEditMode">
					{{ form.value.email3 }}
				</span>
			</div>
		</div>

		<div class="date-modif" *ngIf="!isEditMode && preferencesNotifications.lastDateModification">
			<p>
				{{
					'Preference.DerniereModification'
						| translate
							: {
									dateModification: preferencesNotifications.lastDateModification | date: 'dd/MM/yyyy',
									heureModification: preferencesNotifications.lastDateModification | date: 'HH',
									minuteModification: preferencesNotifications.lastDateModification | date: 'mm',
									utilisateurModification: preferencesNotifications.lastUtilisateurModification
							  }
				}}
			</p>
		</div>

		<div class="edit-btns text-end" *ngIf="isEditMode">
			<button type="button" class="btn btn-secondary btn-cancel" (click)="cancel()" [disabled]="preferenceService?.editLoading$ | async">
				{{ 'Actions.Cancel' | translate }}
			</button>
			<button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="preferenceService.editLoading$ | async">
				<loader-button-spinner [isShowButtonSpinner]="preferenceService.editLoading$ | async"></loader-button-spinner>
				{{ 'Actions.Confirm' | translate }}
			</button>
		</div>
	</form>
</content-block>

<ng-template #contentBlockActions>
	<button type="button" class="btn btn-primary" (click)="edit()" *ngIf="allowEdit && !isEditMode" [disabled]="anyEditMode$ | async">
		<span>
			<i class="far fa-pencil"></i>
			<loader-button-spinner [isShowButtonSpinner]="preferenceService.getLoading$ | async"></loader-button-spinner>
			{{ 'Actions.Edit' | translate }}
		</span>
	</button>
</ng-template>
